require('./style.css');
var tmpl = require('./main.ejs');
var tmplItem = require('./item.ejs');
var util = require('f.core.mobile.util');
var Events = require('f.core.event');

var ChartList = function() {
    this.ids = {};
    this.datas = [];
    this.init();
    this.sends = [];
    this.isStop = false;
    this.atPerson = false; //@艾特用户
};

ChartList.prototype.init = function() {
    this.initDom();
    this.initEvent();
};

ChartList.prototype.initDom = function() {
    var div = document.createElement('div');
    div.innerHTML = tmpl();
    this.el = div.children[0];
    this.elItems = this.el.querySelector('.c-chart__items');
    this.elScroll = this.el.querySelector('.c-chart__scrolls');
    this.elMore = this.el.querySelector('.c-chart__more');
};

ChartList.prototype.initEvent = function() {
    util.tap(
        this.elMore,
        function() {
            var divHeight = this.elScroll.offsetHeight;
            var listHeight = this.elItems.offsetHeight;

            $(this.elMore)
                .stop()
                .animate({ bottom: '-1.667rem' });
            $(this.elScroll)
                .stop()
                .animate({ scrollTop: listHeight - divHeight }, 400);

            // this.elScroll.scrollTop = listHeight - divHeight;
            return false;
        },
        {
            scope: this
        }
    );

    // todo
    // 增加对于全页面拖动的阻止
    this.isTouch = false;

    this.elScroll.addEventListener(
        'touchstart',
        function(event) {
            this.isTouch = true;
            $(this.elScroll).stop();
            this.isScroll = true;
            var scrollTop = this.elScroll.scrollTop;
            if (scrollTop == 0) {
                this.elScroll.scrollTop = 1;
                return;
            }
            var divHeight = this.elScroll.offsetHeight;
            var listHeight = this.elItems.offsetHeight;
            if (listHeight <= scrollTop + divHeight) {
                this.elScroll.scrollTop = scrollTop - 1;
            }
            // event.preventDefault();
        }.bind(this),
        false
    );

    this.touchendTimer = null;

    this.elScroll.addEventListener(
        'touchend',
        function(event) {
            this.isTouch = false;
            // $('#logBox').html($('#logBox').html() + '<br/>touchend');
            this.isScroll = true;
            var listHeight = this.elItems.offsetHeight;
            var divHeight = this.el.offsetHeight;
            var scrollTop = this.elScroll.scrollTop;
            // 用来防止touchend后没有scroll事件触发的情况，
            // 一加一减是为了防止滚动到头和尾的时候，如果超出滚动范围，不会触发滚动的情况。
            // 对于微信（ios）来说，他的scroll事件在touchend触发以后，不会继续触发，只在停止滚动后，才会再触发一下，
            // 这样的话，如果写下面两句，会导致iscroll会被提前结束。但是如果不写，有一种几率在touchend后如果没有惯性位移，会导致无法改变isScroll的状态
            // this.elScroll.scrollTop = scrollTop + 2;
            // this.elScroll.scrollTop = scrollTop - 1;

            // 对于scroll的监控，存在以下几种情况
            // ios（9 10）的微信下面 touchstart scroll*N touchend ...... 停止滚动后 scroll再触发一次
            // iso (9 10) safari touchstart scroll*N touchend scroll*N 直到停止
            // 安卓下面，touchstart scroll*N touchend scroll*N
            // 安卓下面，当内容滚动到底的时候，如果再进行滑动，在touchend后面无法触发scroll，因为安卓的滚动没有回弹。
            // 所有环境下，如果滑动结束时，没有位移，也不会在触发touchend后再次触发scroll事件
            // 现在的解决方案是在touchend是，开一个定时器，以避免后面没有scroll触发的时候导致内容无法更新的问题。
            // console.log('----------------------', event)
            clearTimeout(timer);
            clearTimeout(this.touchendTimer);
            this.touchendTimer = setTimeout(
                function() {
                    this.isScroll = false;
                }.bind(this),
                3000
            );
            event.preventDefault();
        }.bind(this),
        false
    );

    this.elItems.addEventListener(
        'touchstart',
        function(event) {
            this.atPerson = true;
        }.bind(this),
        false
    );

    this.elItems.addEventListener(
        'touchmove',
        function(event) {
            this.atPerson = false;
        }.bind(this),
        false
    );

    this.elItems.addEventListener(
        'touchend',
        function(event) {
            if (this.atPerson) {
                //从父节点中取id和type
                const parentNode = event.target.parentNode;
                const type = parentNode.dataset.type;
                const id = parentNode.dataset.id;
                const nickname = parentNode.dataset.name;

                //当且仅当是普通弹幕才能艾特 并且有id
                if (
                    type === 'danma' &&
                    id != undefined &&
                    id.indexOf('sendBack') < 0
                ) {
                    console.log('trigger', nickname);
                    this.trigger('atPerson', nickname);
                }
            }
            this.atPerson = false;
        }.bind(this),
        false
    );

    var index = 1;

    var timer = null;
    this.isScroll = false;
    this.elScroll.addEventListener(
        'scroll',
        function() {
            // $('#logBox').html($('#logBox').html() + '<br/>only scroll');
            this.isScroll = true;
            var listHeight = this.elItems.offsetHeight;
            var divHeight = this.el.offsetHeight;
            var scrollTop = this.elScroll.scrollTop;

            // console.log('scroll',listHeight - divHeight - scrollTop);
            clearTimeout(this.touchendTimer);
            clearTimeout(timer);
            timer = setTimeout(
                function() {
                    this.isScroll = false;
                    // console.log('timer');
                    var listHeight = this.elItems.offsetHeight;
                    var divHeight = this.el.offsetHeight;
                    var scrollTop = this.elScroll.scrollTop;
                    if (listHeight <= divHeight + scrollTop + 10) {
                        $(this.elMore)
                            .stop()
                            .animate({ bottom: '-1.667rem' });
                        // this.elMore.style.display = 'none';
                    }
                }.bind(this),
                200
            );
            // this.elScroll.style.backgroundColor = 'rgb(255, 255, ' + (index++%255) + ')';
            // console.log('scroll');
        }.bind(this),
        false
    );
};

ChartList.prototype.fliterDatasBySend = function(datas) {
    var result = [];
    var item;
    for (var i = 0, iLen = datas.length; i < iLen; i++) {
        item = datas[i];
        var isSelect = false;
        for (var j = 0, jLen = this.sends.length; j < jLen; j++) {
            if (this.sends[j].content == item.content) {
                this.sends.splice(j, 1);
                isSelect = true;
                break;
            }
        }
        if (!isSelect) {
            result.push(item);
        }
    }
    return result;
};

ChartList.prototype.removeItem = function() {
    var items = $(this.elItems).find('.c-chart__item');
    if (items.length < 200) {
        return;
    }

    var clearItems = items.slice(0, 100);

    var totalHeight = 0;

    clearItems.each(function() {
        totalHeight = totalHeight + $(this).outerHeight();
    });

    var scrollTop = $(this.elScroll).scrollTop();

    if (scrollTop > totalHeight) {
        $(this.elScroll).scrollTop(scrollTop - totalHeight);
    } else {
        $(this.elScroll).scrollTop(0);
    }

    clearItems.remove();
};

ChartList.prototype.fliterDatas = function(datas) {
    datas = this.fliterDatasBySend(datas);
    var result = [];
    var item;
    var now = new Date().valueOf();
    for (var i = 0, iLen = datas.length; i < datas.length; i++) {
        item = datas[i];
        if (typeof item.id == 'undefined') {
            result.push(item);
        } else {
            if (
                typeof item.id == 'string' &&
                item.id.indexOf('sendBack_') >= 0
            ) {
                this.sends.push(item);
            }
            if (!this.ids[item.id]) {
                this.ids[item.id] = now;
                result.push(item);
            } else if (
                now - this.ids[item.id] > 10 * 60 * 1000 &&
                item.__type == 'online'
            ) {
                this.ids[item.id] = now;
                result.push(item);
            }
        }
    }
    return result;
};

ChartList.prototype.add = function(datas) {
    datas = this.fliterDatas(datas);
    if (this.isScroll || this.isTouch || this.isStop) {
        this.datas = this.datas.concat(datas);

        if (this.datas.length > 0) {
            setTimeout(
                function() {
                    this.add([]);
                }.bind(this),
                1000
            );
        }

        return;
    } else {
        // 每次只显示有限数量的消息
        // this.datas = this.datas.concat(datas);
        // datas = this.datas.splice(0, 5);
        // if (this.datas.length > 0) {
        //   setTimeout(function () {
        //     this.add([]);
        //   }.bind(this), 1000);
        // }
        datas = this.datas.concat(datas);
        this.datas = [];
    }

    // 如果过滤后的数据为空的话，则不进行下面的操作。
    if (datas.length <= 0) {
        return;
    }

    $(this.elScroll).stop(true, true);

    console.log(datas);

    if (__urlParams.liveid == '131498') {
        datas[0].praise_type = 'rat';
    }

    this.removeItem();
    // console.log('isScroll', this.isScroll);
    var div = document.createElement('div');
    div.innerHTML = tmplItem({ list: datas });
    var items = div.children;
    var p = document.createDocumentFragment();
    while (items.length > 0) {
        p.appendChild(items[0]);
    }
    var listHeight = this.elItems.offsetHeight;
    var divHeight = this.el.offsetHeight;
    var scrollTop = this.elScroll.scrollTop;
    requestAnimationFrame(
        function() {
            this.elItems.appendChild(p);
            var newListHeight = this.elItems.offsetHeight;
            var addHeight = newListHeight - listHeight;
            if (newListHeight > divHeight) {
                // 加10是因为在安卓版本下面，有可能会有1-2的误差。用10做小范围修正。
                if (listHeight <= scrollTop + divHeight + 10) {
                    // $('#logBox').html($('#logBox').html() + '<br/>' + listHeight - scrollTop - divHeight);
                    // console.log('scroll');
                    listHeight = this.elItems.offsetHeight;
                    divHeight = this.el.offsetHeight;

                    $(this.elScroll)
                        .stop()
                        .animate({ scrollTop: listHeight - divHeight }, 400);
                    $(this.elMore)
                        .stop()
                        .animate({ bottom: '-1.667rem' });
                    // this.elMore.style.display = 'none';
                } else {
                    $(this.elMore)
                        .stop()
                        .animate({ bottom: '0.167rem' });
                    // this.elMore.style.display = 'block';
                }
            }
        }.bind(this)
    );
};

ChartList.prototype.scrollTo = function(offset) {
    var elm = $('[data-offset="' + offset + '"]')[0];
    if (elm) {
        var top = $(elm).position().top;
        // console.log(top);
        $(this.elScroll)
            .stop()
            .animate({ scrollTop: top }, 400);
    }
};

ChartList.prototype.scroll = function(type) {
    var listHeight = this.elItems.offsetHeight;
    var scrollTop = this.elScroll.scrollTop;
    var divHeight = this.el.offsetHeight;
    if (listHeight > scrollTop + divHeight) {
        $(this.elScroll)
            .stop()
            .animate({ scrollTop: listHeight - divHeight }, 400);
    }
};

ChartList.prototype.hideMore = function() {
    $(this.elMore)
        .stop()
        .css({ bottom: '-1.667rem' });
};

ChartList.prototype.resetMore = function() {
    setTimeout(
        function() {
            if (
                this.elScroll.scrollTop + this.el.offsetHeight <
                this.elItems.offsetHeight
            ) {
                $(this.elMore)
                    .stop()
                    .css({ bottom: '-1.667rem' });
            } else {
                $(this.elMore)
                    .stop()
                    .animate({ bottom: '0.167rem' });
            }
        }.bind(this),
        1000
    );
};

ChartList.prototype.stop = function() {
    this.isStop = true;
};

ChartList.prototype.play = function() {
    this.isStop = false;
    this.add([]);
};

ChartList.prototype.renderTo = function(parentNode) {
    parentNode.appendChild(this.el);
    this.elScroll.style.height = this.el.offsetHeight + 'px';
    // this.elScroll.style.height = '100%';
};

ChartList.prototype.destory = function() {
    this.el.parentNode.removeChild(this.el);
};

ChartList.prototype.resize = function() {
    console.log(this.el.offsetHeight);
    this.elScroll.style.height = this.el.offsetHeight + 'px';
};

ChartList.prototype.clear = function() {
    this.ids = {};
    this.datas = [];
    this.sends = [];
    $(this.elItems).empty();
    $(this.elMore)
        .stop()
        .animate({ bottom: '-1.667rem' });
};

Events.mixTo(ChartList);

module.exports = ChartList;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/chartList/index.js